import { BlockConfigSchema } from './blockConfig/Types';
import { z } from 'zod';

export const BlockSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  order: z.number(),
  pageLayoutId: z.string().uuid(),
  blockConfig: BlockConfigSchema.latestVersionSchema,

  loading: z.boolean().optional(),
});

export type Block = z.infer<typeof BlockSchema>;
